import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AUTHGWCONSTANTS } from 'src/app/authorization/authconstatnts';
@Injectable({
  providedIn: 'root',
})
export class HomeService {

  public static dialogResult = false;
  headers: any;

  constructor(private http: HttpClient) {
    const xenAuth = localStorage.getItem(AUTHGWCONSTANTS.xenAuth);
    const guestAuth = localStorage.getItem(AUTHGWCONSTANTS.guestAuth);
    this.headers = { 'XEN-AUTHORIZATION': xenAuth ? xenAuth : guestAuth };
    this.headers = { ...this.headers, ...environment.platformInfo };
  }

  getHomeSliderSection(urlParams: any): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl + '/api/elemnts/section', {
      headers: this.headers,
      params: urlParams,
    });
  }

  getCategories(): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl + '/api/resource/parent/category', {
      headers: this.headers,
    });
  }

  getSellingProducts(): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl + '/api/sales/top/selling/product', {
      headers: this.headers,
    });
  }
}
